import React, { useEffect, useState } from 'react';

import Login from '../../../features/authentication/login/Login';

/**
 * Global Login Manager description:
 * - Listens for window event 'app:open-login' to open the login modal.
 * - Ensures the login modal can be triggered from anywhere without page reloads.
 */
const LoginManager = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    if (typeof window !== 'undefined') {
      window.addEventListener('app:open-login', handler as EventListener);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('app:open-login', handler as EventListener);
      }
    };
  }, []);

  if (!visible) {
    return null;
  }

  return <Login onClose={() => setVisible(false)} />;
};

export default LoginManager;
